<template>
  <article class="message" :class="'is-' + type">
    <div class="message-header">
      <p>{{ title }}</p>
    </div>
    <div class="message-body">
      <p>{{ description }}</p>

      <div v-if="state === 'initial'" class="buttons" style="margin-top: 1rem;">
        <button class="button" :class="'is-' + type" @click="onAcceptClick">
          {{ acceptLabel }}
        </button>
        <button class="button" @click="$emit('decline')">
          {{ declineLabel }}
        </button>
      </div>

      <div v-if="state === 'input'" style="margin-top: 1rem;">
        <div class="field">
          <label class="label">{{ inputLabel }}</label>
          <p class="control">
            <input
              class="input"
              :type="inputType"
              v-model="inputValue"
              :placeholder="inputPlaceholder"
            />
          </p>
        </div>
        <button class="button" :class="['is-' + type, { 'is-loading': loading }]" @click="submit">
          {{ submitLabel || $t('app.buttons.confirm') }}
        </button>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    acceptLabel: { type: String, required: true },
    declineLabel: { type: String, required: true },
    type: { type: String, default: 'info' },
    showInput: { type: Boolean, default: false },
    inputLabel: { type: String, default: '' },
    inputPlaceholder: { type: String, default: '' },
    inputType: { type: String, default: 'text' },
    submitLabel: { type: String, default: '' }
  },
  data () {
    return {
      state: 'initial',
      inputValue: '',
      loading: false
    }
  },
  methods: {
    onAcceptClick () {
      if (this.showInput) {
        this.state = 'input'
      } else {
        this.$emit('accept', {})
      }
    },
    submit () {
      this.loading = true
      this.$emit('accept', { inputValue: this.inputValue || null })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InfoBox.vue